export default __webpack_public_path__ + "static/modal04_01-pc-80880bb64662b2ea0eeb1b199616d68f.png";